import React from 'react'
import Contactus from '../Common/Contactus'
import MainBanner from '../page_content/MainBanner'
import whiterightarrow from "../../assets/images/white-rightarrow.svg";
import blackrightarrow from "../../assets/images/blackrightarrow.svg";
import sideCartimg from "../../assets/images/educationimg.png";
import closeicon from "../../assets/images/closeicon.svg";
import Header from '../Common/Header';

const Education = () => {
    return (
        <>
            <Header />

            <div>
                <MainBanner page="PRODUCTS" />
                <section className=" aboutsection2" id="single-product">
                    <div className="container ">
                        <div className="bg-white">
                            <div className="text-section">
                                <h2 className="text-purple">Education

                                </h2>
                                <p className="fw-medium">Courses for student</p>
                                <div>
                                    Online Marketplace:&nbsp;The Education Website Project is designed to create an interactive, user-friendly platform that offers educational resources, courses, and tools for students, teachers, and institutions. The website will cater to learners of all ages and provide a wide range of content, from primary education to advanced professional courses. Its goal is to offer a centralized hub for learning, enabling users to access materials anytime and anywhere.

                                </div>
                                <div>
                                    Product Catalogue:&nbsp;
                                    The platform will feature a variety of learning formats, including video tutorials, interactive quizzes, downloadable resources, and live classes, to accommodate different learning styles. Students can register for courses, track their progress, and receive certifications upon completion. Teachers will have the ability to create courses, upload materials, and manage student participation with easy-to-use tools.

                                </div>
                                <div className="d-flex">
                                    <a
                                        href="#demo-modal"
                                        className="btn btn-black btn-purple  text-white"
                                    >
                                        View Project
                                        <img src={whiterightarrow} alt="" />
                                    </a>
                                </div>
                            </div>
                            <div className="image-section">
                                <img src={sideCartimg} alt="" />
                            </div>
                        </div>
                        <div id="demo-modal" className="modal">
                            <div className="modal__content">
                                <h2 className="text-purple">Get A Free Demo</h2>
                                <p className="fw-medium">
                                    Embrace Opportunity: A Pathway to Success
                                </p>
                                <div className="form-container">
                                    <div className="form-group">
                                        <label htmlFor="product">Select Product:</label>
                                        <select id="product" name="product">
                                            <option value="product1">Comercio</option>
                                            <option value="product2">Product 2</option>
                                            <option value="product3">Product 3</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="name">Name:</label>
                                        <input
                                            type="text"
                                            id="name"
                                            placeholder="MCL"
                                            name="name"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            type="email"
                                            placeholder="info@gmail.com"
                                            id="email"
                                            name="email"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone:</label>
                                        <input
                                            type="tel"
                                            placeholder="+91 9896570012"
                                            id="phone"
                                            name="phone"
                                            required
                                        />
                                    </div>
                                    <div className="form-group full-width">
                                        <label htmlFor="message">Message:</label>
                                        <textarea
                                            id="message"
                                            name="message"
                                            placeholder="Enter your message here"
                                            required
                                            defaultValue={""}
                                        />
                                    </div>
                                    <div className="form-group full-width button">
                                        <button className="btn btn-black" type="submit">
                                            Get a demo
                                        </button>
                                    </div>
                                </div>
                                <a href="#" className="modal__close">
                                    <img src={closeicon} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className id="Comercio-discription">
                    <div className="container ">
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold">Diverse Learning Formats:&nbsp;</span>
                                The platform offers a variety of formats such as video tutorials, interactive quizzes, downloadable resources, and live classes to accommodate different learning styles.

                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                    Course Registration & Tracking:
                                </span>
                                Students can register for courses, track their progress, and receive certifications upon successful completion, enhancing the learning journey.

                            </div>
                            <div>
                                <span className="fw-semi-bold">Teacher Tools & Course Creation:

                                    &nbsp;</span>
                                Educators can easily create courses, upload materials, and manage student participation with user-friendly course management tools.

                            </div>

                        </div>
                        <div className="card-container bg-white text-gray">
                            <div>
                                <span className="fw-semi-bold">
                                    Institutional Integration:

                                    &nbsp;
                                </span>
                                Schools and institutions can integrate their curricula, offering online classes and managing student enrollment through the platform.

                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                    Community Engagement:

                                    &nbsp;
                                </span>
                                &nbsp;The platform includes forums, discussion boards, and collaborative spaces where students and teachers can interact, share knowledge, and support each other.

                            </div>
                            <div>
                                <span className="fw-semi-bold">
                                    Mobile Optimization & Data Security:


                                    &nbsp;&nbsp;
                                </span>
                                &nbsp;The site is optimized for mobile devices and prioritizes secure data storage, ensuring that users can learn safely and conveniently from anywhere.



                            </div>
                        </div>
                    </div>
                </section>
                <Contactus />
            </div></>
    )
}

export default Education